<template>
  <div class="rank-list">
    <EmptyState v-if="!items.length" :title="''" :msg="emptyMsg" />
    <component
      :is="item.linkTo ? 'router-link' : 'div'"
      v-for="(item, i) in items"
      :key="item.id ?? i"
      :to="item.linkTo"
      class="rank-item"
    >
      <span class="rank-fill" :style="{ width: (item.perc || 0) + '%' }"></span>
      <span class="rank-pos" :class="rankClass(i)">{{ i + 1 }}</span>
      <span class="rank-avatar">{{ initials(item.name) }}</span>
      <span class="rank-info">
        <span class="rank-name">{{ item.name }}</span>
        <span v-if="item.subtitle" class="rank-email">{{ item.subtitle }}</span>
      </span>
      <span class="rank-count">
        {{ item.value }}
        <small v-if="item.unit">{{ item.unit }}</small>
      </span>
    </component>
  </div>
</template>

<script>
export default {
  name: "DashRankList",
  props: {
    // [{ id, name, subtitle, value, unit, perc, linkTo }]
    items: { type: Array, default: () => [] },
    emptyMsg: { type: String, default: "Nada por aqui ainda." },
  },
  methods: {
    initials(name) {
      if (!name) return "?";
      const parts = String(name).trim().split(/\s+/);
      const first = parts[0] ? parts[0][0] : "";
      const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
      return (first + last).toUpperCase();
    },
    rankClass(i) {
      return i === 0 ? "gold" : i === 1 ? "silver" : i === 2 ? "bronze" : "";
    },
  },
};
</script>

<style scoped>
.rank-list {
  max-height: 380px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 4px;
}
.rank-item {
  position: relative;
  flex: 0 0 auto;
  min-height: 52px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 10px;
  background-color: #f7f9fc;
  overflow: hidden;
  text-decoration: none;
  transition: background-color 0.15s;
}
.rank-item:hover {
  background-color: #eef2f8;
}
.rank-fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(90deg, rgba(42, 183, 206, 0.16), rgba(42, 183, 206, 0.04));
  z-index: 0;
}
.rank-pos,
.rank-avatar,
.rank-info,
.rank-count {
  position: relative;
  z-index: 1;
}
.rank-pos {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.72rem;
  font-weight: 700;
  color: #8896a6;
  background-color: #e6ebf2;
}
.rank-pos.gold {
  color: #7a5c00;
  background-color: #ffe08a;
}
.rank-pos.silver {
  color: #4a5560;
  background-color: #d7dee6;
}
.rank-pos.bronze {
  color: #7a4a24;
  background-color: #f0c9a6;
}
.rank-avatar {
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.72rem;
  font-weight: 700;
  color: #fff;
  background-color: #5b6bb5;
}
.rank-info {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.rank-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #12263f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rank-email {
  font-size: 0.72rem;
  color: #8896a6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rank-count {
  flex: 0 0 auto;
  text-align: right;
  font-size: 1.05rem;
  font-weight: 700;
  color: #123766;
  line-height: 1;
}
.rank-count small {
  display: block;
  font-size: 0.62rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #8896a6;
}
</style>
